import * as React from "react";
import { css } from "@emotion/react";
import { useTranslation } from "react-i18next";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { borderRadius } from "main/javascripts/styles/base/borderStyle";

export const HotelRoomNotAvailableMessage = () => {
  const { t } = useTranslation(["component"]);

  return (
    <div css={blockStyle}>
      <div css={innerStyle}>{t("hotelShow.roomNotAvailableMessage")}</div>
    </div>
  );
};

const blockStyle = css`
  padding: 0 ${space.atom};
  margin: 5rem auto;
  max-width: 35rem;
`;
const innerStyle = css`
  padding: ${space.atom3x} ${space.atom2x};
  text-align: center;
  font-size: ${fontSize.body};
  font-weight: ${fontWeight.medium};
  line-height: ${lineHeight.body2};
  background: rgba(0, 0, 0, 0.025);
  border-radius: ${borderRadius.normal};
`;
